@if (isPermissionsReady() || isPublicView()) {
  <app-header></app-header>

  <mat-sidenav-container class="sidenav-container" [hasBackdrop]="false"
    [class.height_le_l]="isFooterAvailable && (size$ | async).less('l')">
    <mat-sidenav #sidenav
      [autoFocus]="false"
      [mode]="(size$ | async)?.less('l') ? 'over' : 'side'"
      [ngClass]="{'background_le_l': (size$ | async).less('l')}"
      [(opened)]="opened"
      (touchstart)="onTouchStart($event)"
      (touchend)="onTouchEnd($event)"
      class="sidenav">
      <app-side-nav [showNotificationPanel]="!isPublicInterface"></app-side-nav>
    </mat-sidenav>

    <mat-sidenav-content class="sidenav-content">
      @if ((size$ | async).more('m')) {
        <div class="toggle-arrow"
             [class.not-shown]="!isSideNavAvailable"
             (click)="sidenav.toggle(); updateMap()">
          @if (opened) {
            <mat-icon>keyboard_arrow_left</mat-icon>
          }
          @if (!opened) {
            <mat-icon>keyboard_arrow_right</mat-icon>
          }
        </div>
      }

      @if (loadingComplete) {
        <router-outlet></router-outlet>
      }

    </mat-sidenav-content>
  </mat-sidenav-container>

  <app-footer></app-footer>
}

